/** POC: isRobotReadyMachineId — RR suffix = robot-ready (no MSPe auto-feed on compare). */
export function isRobotReadyProductId(productId: string): boolean {
  return /RR$/i.test(String(productId || "").trim());
}

/** POC: inferMachineFamilyKey — MSPe / MSP / EDRIVE family. */
export function inferMachineFamilyKey(productId: string): string | null {
  const id = String(productId || "").toUpperCase();
  if (!id) return null;
  if (id.includes("EDRIVE")) return "MSPE";
  if (id.includes("MSPE") || id.includes("MSP")) return "MSPE";
  return null;
}

/** POC: isMspAutoFeedToggleSupported — compare card auto-feed chip. */
export function isMspAutoFeedToggleSupported(productId: string): boolean {
  return inferMachineFamilyKey(productId) === "MSPE" && !isRobotReadyProductId(productId);
}
